<script setup lang="ts">
import { FeatureNameMap } from "~/types/feature.types";

const {
  autoAdvance,
  autoplay,
  setAutoAdvance,
  setAutoplay,
} = useUserPreferences();
const { course } = useCourseState();
const { t } = useI18n();
const { isFeatureEnabled } = useFeatures();

const autoAdvanceActive = ref(unref(autoAdvance));
const autoplayActive = ref(unref(autoplay));

watch(autoplayActive, newVal => {
  setAutoplay(newVal);
});

watch(autoAdvanceActive, newVal => {
  setAutoAdvance(newVal);
});
</script>

<template>
  <div class="p-4">
    <div class="text-24 text-neutral-90 font-bold mb-4">
      {{t('course.sidebar.tabs.preferences.playbackPreferences.title')}}
    </div>

    <div class="flex flex-col gap-2">
      <label class="flex items-center justify-between">
        <div class="description">
          {{t('course.sidebar.tabs.preferences.playbackPreferences.settings.autoplayVideos.title')}}
        </div>

        <div class="input">
          <InputSwitch v-model="autoplayActive" />
        </div>
      </label>

      <label class="flex items-center justify-between">
        <div class="description">
          {{t('course.sidebar.tabs.preferences.playbackPreferences.settings.autoAdvanceLesson.title')}}
        </div>

        <div class="input">
          <InputSwitch v-model="autoAdvanceActive" />
        </div>
      </label>

      <label
        v-if="isFeatureEnabled(FeatureNameMap.Multilungual)"
        class="flex items-center justify-between"
      >
        <div class="description">
          {{t('course.sidebar.tabs.preferences.playbackPreferences.settings.language.title')}}
        </div>

        <div class="input">
          <LanguageSwitch
            v-if="course?.availableLanguages && course.availableLanguages.length > 1"
            class="mr-4"
            size="26px"
            :languages="course.availableLanguages"
          />
        </div>
      </label>
    </div>
  </div>
</template>
